import { TFunction } from 'i18next';
import { useCallback } from 'react';
import { ToasterObject, ToasterState } from './redux/types';
import ToasterItemComponent from './toaster-item-component';
import './toaster-styles.scss';

interface ToasterProps {
  addTimeout: (toaster: ToasterObject) => void;
  deactivateToaster: (id: number) => void;
  removeToaster: (index: number) => void;
  t: TFunction;
  toasters: ToasterState;
}

type UsedIds = {
  onDeactivate: Array<number>
  onRemove: Array<number>
}

export default function ToasterComponent({ deactivateToaster, removeToaster, toasters }: ToasterProps) {
  const usedIds: UsedIds = {
    onDeactivate: [],
    onRemove: [],
  }

  const deactivateToasterCallback = useCallback((toasterId: number) => {
    if(!usedIds.onDeactivate.includes(toasterId)) {
      deactivateToaster(toasterId)
      usedIds.onDeactivate.push(toasterId)
    }
  }, [])

  const removeToasterCallback = useCallback((toasterId: number) => {
    if(!usedIds.onRemove.includes(toasterId)) {
      removeToaster(toasterId)
      usedIds.onRemove.push(toasterId)
    }
  }, [])

  return (
    <div className="toaster-container">
      {toasters?.toasters.length > 0 &&
        toasters.toasters.map((item: ToasterObject, index: number) => {
          return (
            <ToasterItemComponent
              toaster={item}
              deactivateToaster={deactivateToasterCallback}
              removeToaster={removeToasterCallback}
              index={index}
              key={index}
            />
          );
        })}
    </div>
  );
}
